import React from 'react';
import { useP } from '../i18n/useP';
import '../styles/designSystem.css';

/* Champ de recherche — zone 6 du standard de carte : TOUJOURS le dernier
   élément à droite de la toolbar. Loupe à gauche, placeholder qui décrit ce
   qu'on peut y chercher (« Service… », « Service, segment, personne… »). */
export default function SearchField({ value, onChange, placeholder = null, ariaLabel = null }) {
  const p = useP();
  return (
    <span className="lk-search">
      <svg className="lk-search__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
      </svg>
      <input
        type="search"
        className="lk-filter-input lk-search__in"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder || p('Rechercher…')}
        aria-label={ariaLabel || placeholder || p('Rechercher')}
      />
    </span>
  );
}
